import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-partner',
  template: `
    <h3 data-cy="select-partner-title">Select a Partner to represent in this session.</h3>
    <app-partner-select (partnerSelect)="onSelect()" name="login-select-partner"></app-partner-select>`,
  styleUrls: [
    'partner.component.scss'
  ]
})

export class PartnerComponent {

  constructor(private router: Router) {
  }

  onSelect() {
    this.router.navigate(['segments']);
  }
}
